import Vue from 'vue'

let paypalClientId = ''

if (process.env.NODE_ENV === 'production') {
  paypalClientId = process.env.PAYPAL_CLIENT_ID_PRO
} else {
  paypalClientId = process.env.PAYPAL_CLIENT_ID_DEV
}

const paypalSdkUrl = paypalClientId ? `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&commit=true&currency=USD` : ''

const global = {
  URL: process.env.BASE_URL,
  IMGPATH: 'https://www.stylool.com',
  SRTRIPE_public_key_dev: process.env.STRIPE_PUBLIC_KEY_DEV,
  SRTRIPE_public_key_pro: process.env.STRIPE_PUBLIC_KEY_PRO,
  SRTRIPE_LINK: 'https://js.stripe.com/v3',
  PAYPAL_SDK_URL: paypalSdkUrl
}

Vue.prototype.GLOBAL = global
